/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBreathing = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16 20a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-8.4-6c1.915 0 3.4 1.606 3.4 3.5S9.515 21 7.6 21c-1.916 0-3.4-1.606-3.4-3.5h2c0 .867.665 1.5 1.4 1.5.735 0 1.4-.633 1.4-1.5S8.335 16 7.6 16H2v-2z" />
        <path d="M17.919 11C20.148 11 22 12.766 22 15s-1.853 4-4.081 4-4.081-1.766-4.081-4h2c0 1.08.906 2 2.08 2C19.095 17 20 16.08 20 15s-.906-2-2.081-2H2v-2zM14 2a4 4 0 0 1 0 8H2V8h12a2 2 0 1 0-2-2h-2a4 4 0 0 1 4-4zm7 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgBreathing as Breathing };
